import Cta from "@components/Cta/Cta";
import { ProgrammeDetails } from "@customTypes/programmeDetails";
import { useContext } from "react";
import { UserContext } from "../../context/user";
import { useApplicationLink,handleApplyClick } from "@utilities/applicationLinkHelper";

export interface ProgrammeApplyNowLinkProps {
  profileProgramme: { fields: ProgrammeDetails };
  linkText: string;
}

export const ProgrammeApplyNowLink = (props: {
  content: ProgrammeApplyNowLinkProps;
}) => {
  const { content } = props;
  const { profileProgramme, linkText } = content;
  const programme = profileProgramme.fields?.programmeTypeCode;
  const applyID = profileProgramme.fields?.programmeApplyOnlineParameterValue;
  const isSalesforceApplication = profileProgramme.fields?.applicationInSalesforce;
  const { user } = useContext(UserContext);
  const applyNowUrl = useApplicationLink({user: !!user, programmeApplyOnlineId: applyID, isSalesforceApplication});

  if (!programme || !applyID ) return null;

  return (
    <>
      <p>Submit your application through our online application form.</p>
      <div className="button-wrapper" style={{ width: "200px" }}>
        <Cta
          linkText={linkText}
          type="primary"
          url={applyNowUrl}
        />
      </div>
    </>
  );
};

export default ProgrammeApplyNowLink;
